var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('staff-list',_vm._g({attrs:{"items":_vm.items,"noInvite":""}},{ select: _vm.select, create: _vm.create, search: _vm.search }))}
var staticRenderFns = []

export { render, staticRenderFns }